import { IconProps } from './types'

export default function IconReload({
    width = '64',
    height = '64',
    className,
}: IconProps) {

    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 64 64'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path d='M28.0815 35.9419L21.2188 35.8003C32.3477 44.397 46.2017 45.4982 56.5537 43.3579C42.0668 54.2407 23.5864 50.438 15.4102 44.9429L16.7173 50.1826L9.55713 56.3472L6.65234 30.4966L32.5034 27.5923L28.0815 35.9419Z' fill='#5486AC' />
            <path d='M57.1128 33.8252L31.1899 35.9971L35.8462 27.7754L42.7026 28.1113C31.8214 19.2033 18.0041 17.7106 7.5957 19.5571C22.3846 9.08868 40.7495 13.4125 48.7671 19.1367L47.6089 13.8623L54.9409 7.90234L57.1128 33.8252Z' fill='#5486AC' />
        </svg>
    )
}
